
import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import IndustriesSection from './components/IndustriesSection';
import ServicesSection from './components/ServicesSection';
import ApproachSection from './components/ApproachSection';
import WhyScaleNorthSection from './components/WhyScaleNorthSection';
import PerformanceSection from './components/PerformanceSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';
import ConsultationModal from './components/ConsultationModal';

export default function HomePage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onOpenModal={() => setShowModal(true)} />
      <HeroSection onOpenModal={() => setShowModal(true)} />
      <IndustriesSection />
      <ServicesSection />
      <ApproachSection />
      <WhyScaleNorthSection />
      <PerformanceSection />
      <CTASection onOpenModal={() => setShowModal(true)} />
      <FooterSection />
      <ConsultationModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}
